import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { authenticationService } from "../../../services/context/AuthService";
import ModalManualAdjustment from "./ModalManualAdjustment";
import Swal from "sweetalert2";
import moment from "moment";
import {  Button, IconPlus,Table, Search, Select} from "@veneer/core";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import XLSX from 'xlsx';
import $ from 'jquery';
const connectApi = new ConnectAPI();
function ManualAdjustment(props) {
    const { id } = props.match.params;
    const [datatable, setdatatable]=useState([]);
    const [showSCDetail, setShowSCDetail] = useState(false);
    const [lastpublication,setlastpublication]=useState("");
    const [ManualAdjustmentDetail, setManualAdjustmentDetail]=useState([]);
    const [idmanualAdjustment, setidmanualAdjustment]=useState(0);
    const hideSCDetailsModal = () => {
      setShowSCDetail(false);
    }
    function descendingComparator(a, b, orderBy) {
      const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
      const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
      if (orderBy=="idSpecialCondition"){
        if (parseInt(bSort) < parseInt(aSort)) {
          return -1;
        }
        if (parseInt(bSort) > parseInt(aSort)) {
          return 1;
        }
      }else if(orderBy=="startDate" || orderBy=="endDate" || orderBy=="value"){
        if (Date.parse(bSort) < Date.parse(aSort)) {
          return -1;
        }
        if (Date.parse(bSort) > Date.parse(aSort)) {
          return 1;
        }
      }else{
        if (bSort < aSort) {
          return -1;
        }
        if (bSort > aSort) {
          return 1;
        }
      }
      
      return 0;
    }
    
    function sort(array, orderBy, orderType) { 
      return array.sort((a, b) => {
        const value = (orderType === 'descending')
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);
    
        return value;
      });
    }
    function filter(array, filters) {
      let arrayFiltered = array;
      Object.keys(filters).forEach((value) => {
        const filterValue = filters[value];
        const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
        if (filter) {
          arrayFiltered = arrayFiltered.filter((a) => {
            const aUpper = a[value] && a[value].toString().toUpperCase();
            const filterUpper = filter && filter.toString().toUpperCase();
            return aUpper.indexOf(filterUpper) > -1;
          });
        }
      });
      return arrayFiltered;
    }
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    useEffect(()=>{
        //validate location
        /*let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
        });
        if (validate==false){
        const { history } = props;
            history.push({
            pathname: '/' 
            });
        }*/
        //end validate
        start();
    },[]);
    const allook=()=>{
      window.location.reload();
    }
    const start=()=>{
        connectApi
        .get("api/Channels/getmanualadjustment","",consolid)
        .catch((error) => {
            console.log(error);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
    }
    const consolid = (status, data) => {
      setlastpublication(data.lastPublication["startDate"]);
      setdatatable(data.result);

      if(id!=undefined){
          var idfound = props.match.params.id;
          let ma = data.result.find(ma => ma.idAdjustment == idfound);
          setidmanualAdjustment(idfound);
          setManualAdjustmentDetail(ma);
          setShowSCDetail(true);
      }
    }
    const [t, i18n] = useTranslation();
    const AdjustmentTable = () => {
        const [orderBy, setOrderBy] = useState('monthYear');
        const [orderType, setOrderType] = useState('descending');
        const [currentPage, setCurrentPage] = useState(1);
        const handlePageChange = (page) => setCurrentPage(page);
        const [pageSize, setPageSize] = useState(15);
        const [customerFilter,setcustomerFilter]=useState("");
        const [enduserFilter, setenduserFilter]=useState("");
        const [pressFilter, setpressFilter]=useState("");

        const [selectmonthyear, setselectmonthyear]=useState([]);
        const [monthyears, setmonthyears]=useState([]);
        

        if (datatable.length>0 && selectmonthyear.length==0){
          var result=sort(datatable, "ascending", "monthYear").map(item=>item.monthYear).filter(onlyUnique);
          //var result=datatable.map(item=>item.monthYear).filter(onlyUnique);
    
          var item_data=[];
          result.forEach(function(task){
            item_data.push({
              value:moment(task).format("DD/MMM/YYYY"),
              label:moment(task).format("MMM/YYYY")
            });
          });
          const sortedArray = item_data.sort((a, b) => moment(b.value, "DD/MMM/YYYY").unix() - moment(a.value, "DD/MMM/YYYY").unix());
          console.log(sortedArray);
          console.log("salida-----");


          

          setmonthyears(sortedArray);
          setselectmonthyear([moment(sortedArray[0].value).format("DD/MMM/YYYY")]);
        }
        

        const handleOnColumnReorder = (newOrder) => {
            setOrderActive(newOrder);
            setOrder(newOrder);
        };
        const ConfigColumns=[
            {
              id:"idAdjustment",
              label:"idAdjustment"
            },
            {
              id: 'customerName',
              label: 'customerName',
              filter: (
                <Search
                  id="customerFilter"
                  value={customerFilter}
                  onChange={setcustomerFilter}
                />
              ) 
            },
            {
              id: 'endUserName',
              label: 'endUserName',
              filter: (
                <Search
                  id="enduserFilter"
                  value={enduserFilter}
                  onChange={setenduserFilter}
                />
              )
            },
            {
              id: 'idPress',
              label: 'idPress',
              filter: (
                <Search
                  id="pressFilter"
                  value={pressFilter}
                  onChange={setpressFilter}
                />
              )
            },
            {
                id:'monthYear', 
                label:'monthYear',
                filter:(
                  <Select
                    id="monthyearFilter"
                    options={monthyears}
                    onChange={(value)=>{
                      setselectmonthyear([value.value])
                    }}
                    value={selectmonthyear}
                  />
                )
            },
            {
                id: 'bonus',
                label: 'bonus',
            },
            {
                id: 'compensation',
                label: 'compensation',
            },
            {
                id: 'creditNote',
                label: 'creditNote',
            },
            {
              id:'status',
              label:'status'
            }
        ];
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
        
        const [orderActive, setOrderActive] = useState(
            ConfigColumns.map((c) => c.id)
          );
        let filteredData=filter(datatable,
            {
              customerName:customerFilter,
              endUserName:enduserFilter,
              idPress:pressFilter,
              monthYear:selectmonthyear
            }
          );
        let pagdata=sort(filteredData, orderBy, orderType).slice(
          (currentPage - 1) * pageSize,
          (currentPage - 1) * pageSize + pageSize
        );
        console.log(pagdata);
        console.log("salida-----------");
        function activateLasers(e) {
          var id = $(e.target).closest('tr').children().eq(0).text();
          if (id!="idAdjustment" && id!="" && id!="No Items Found"){
            let ma = datatable.find(ma => ma.idAdjustment == id);
            setidmanualAdjustment(id);
            setManualAdjustmentDetail(ma);
            setShowSCDetail(true);
              
          }
        }
       
        return(<>
         <Table
            onClick={activateLasers}
            columns={ConfigColumns}
            data={pagdata}
            showFilters
            onColumnReorder={handleOnColumnReorder}
            columnReorder
            onSort={handleSort}
            preferences={{
              defaultOrder: ConfigColumns.map((c) => c.monthYear),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              }
            }}
            pagination={{
                currentPage,
                onPageChange: handlePageChange,
                pageSize,
                totalItems: filteredData.length,
              }}
        />
        </>);
    }
    return(<>
        <Row>
            <Col>
                <Button
                    leadingIcon={<IconPlus />}
                    onClick={() => {setShowSCDetail(true);}}
                >{t("addNew")} Manual Adjustment</Button>
            </Col>
        </Row>
        <AdjustmentTable/>
        <ModalManualAdjustment 
          currentuser={JSON.parse(localStorage.getItem("currentUser"))}
          lastPublication={lastpublication}
          onShowModal={showSCDetail} 
          onCloseSCDetailsModal={hideSCDetailsModal} 
          confirmationFunction={allook} 
          idManualAdjustment={idmanualAdjustment} 
          ManualAdjustmentDetail={ManualAdjustmentDetail}/>
    </>);
}

export default ManualAdjustment;